/**
 * PLP product card — swipe (touch) to reveal the second image.
 * Desktop hover is handled in CSS (theme.css).
 */
(() => {
  const cards = document.querySelectorAll('[data-product-card]');
  if (!cards.length) return;

  cards.forEach((card) => {
    const media = card.querySelector('[data-card-media]');
    const secondary = card.querySelector('[data-card-image-secondary]');
    if (!media || !secondary) return;

    let touchStartX = 0;
    let touchDelta = 0;
    let suppressClick = false;

    const showSecondary = () => media.setAttribute('data-show-alt', 'true');
    const showPrimary = () => media.removeAttribute('data-show-alt');

    card._showPrimaryImage = showPrimary;

    media.addEventListener(
      'touchstart',
      (event) => {
        touchStartX = event.changedTouches[0].screenX;
        touchDelta = 0;
        suppressClick = false;
      },
      { passive: true }
    );

    media.addEventListener(
      'touchmove',
      (event) => {
        touchDelta = event.changedTouches[0].screenX - touchStartX;
      },
      { passive: true }
    );

    media.addEventListener(
      'touchend',
      () => {
        if (Math.abs(touchDelta) < 48) return;
        suppressClick = true;
        if (touchDelta < 0) showSecondary();
        else showPrimary();
      },
      { passive: true }
    );

    media.addEventListener(
      'click',
      (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      },
      true
    );
  });
})();
